import { ASComponentSize } from 'types/App.types';

export enum LoaderType {
  Grow = 'Grow',
  Spin = 'Spin',
  Dots = 'Dots',
}

export type SizeToCLsType = {
  [key in ASComponentSize]: string;
};
